// extracted by mini-css-extract-plugin
export var body = "Page-module--body--VhxOl";
export var inner = "Page-module--inner--SzHbJ";
export var page = "Page-module--page--JOA3M";
export var title = "Page-module--title--kDOIG";